import { render, staticRenderFns } from "./ProductsReport.vue?vue&type=template&id=692ae327&scoped=true&"
import script from "./ProductsReport.vue?vue&type=script&lang=js&"
export * from "./ProductsReport.vue?vue&type=script&lang=js&"
import style0 from "./ProductsReport.vue?vue&type=style&index=0&id=692ae327&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692ae327",
  null
  
)

export default component.exports